// extracted by mini-css-extract-plugin
export default {"walletContainer":"afterpay-component_walletContainer__UPPhR","mainDiv":"afterpay-component_mainDiv__TPw4K","mainContainer":"afterpay-component_mainContainer__IYshE"};